import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { TabItemComponent } from './tab-item/tab-item.component';

@Component({
	selector: 'app-tab-container',
	templateUrl: './tab-container.component.html',
	styleUrls: ['./tab-container.component.scss']
})
export class TabContainerComponent implements AfterContentInit {
	@Input() selectedIndex: number = 0;
	@Output() selectedIndexChange = new EventEmitter<number>();
	@Output() tabChange = new EventEmitter<{ index: number; tab: TabItemComponent }>();

	@ContentChildren(TabItemComponent) tabs!: QueryList<TabItemComponent>;

	ngAfterContentInit() {
		if (this.tabs.length > 0) {
			// Defer to avoid ExpressionChangedAfterItHasBeenCheckedError
			setTimeout(() => {
				this.selectTab(this.selectedIndex);
			}, 0);
		}
	}

	selectTab(index: number) {
		if (index >= 0 && index < this.tabs.length) {
			this.selectedIndex = index;
			this.selectedIndexChange.emit(index);

			this.tabs.forEach((tab, i) => {
				tab.isActive = i === index;
			});

			const selectedTab = this.tabs.toArray()[index];
			this.tabChange.emit({ index, tab: selectedTab });
		}
	}

	onTabClick(index: number) {
		this.selectTab(index);
	}
}
